import {
  SET_CONTRACTS_TYPE,
  GET_CONTRACTS_TYPE,
  MATCH_CONTRACT_SUCCESS,
  GET_CONTRACTS_AUTO,
  SET_CONTRACTS_AUTO,
  GET_CONTRACTS_AUTO_FAILED,
  SET_CONTRACT_INFO,
  GET_CONTRACT_DETAIL,
  GET_CONTRACT_DETAIL_FAILED,
  SET_CONTRACT_DETAIL,
  SET_CONTRACT_DETAIL_FILES,
  SET_CONTRACT_DETAIL_SERVICES,
  SET_CONTRACT_DETAIL_GARANTIES,
  GET_CONTRACTS_MRH,
  SET_CONTRACTS_MRH,
  GET_CONTRACTS_MRH_FAILED,
  ADD_NEW_CONTRACT,
  ADD_NEW_CONTRACT_FAILED,
  OPEN_MODAL_SUCCESS_CONTRACT,
  CLOSE_MODAL_SUCCESS_CONTRACT,
  OPEN_ADD_NEW_CONTRACT_MODAL,
  CLOSE_ADD_NEW_CONTRACT_MODAL,
  GET_DETAILS_CONTRACT_MRH,
  SET_DETAILS_CONTRACT_MRH,
  SET_DETAILS_CONTRACT_MRH_FAILED,
  SET_DETAILS_CONTRACT_MRH_GARANTIES,
  SET_DETAILS_CONTRACT_MRH_FILES,
  GET_CONTRACTS_EPARGN,
  SET_CONTRACTS_EPARGN,
  GET_CONTRACTS_EPARGN_FAILED,
  GET_PRODUIT_EPARGN,
  SET_PRODUIT_EPARGN_SUCCESS,
  GET_PRODUIT_EPARGN_FAILED,
  SET_AUTH_CONTRACT_EPARGN_INFO,
  SET_CONTRACTS_AMC,
  GET_CONTRACTS_AMC,
  GET_CONTRACTS_AMC_FAILED,
  SET_CONTRACT_AMC_BENEFICIARIES,
  GET_CONTRACT_AMC_BENEFICIARIES_FAILED,
  GET_CLIENT_CONTRACT_ASI,
  SET_CLIENT_CONTRACT_ASI,
  GET_CONTRACTS_AMC_DETAIL,
  SET_CONTRACTS_AMC_DETAIL,
} from 'store/contract/constants';
import {
  ActionWithPayloadType,
  ActionWithoutPayloadType,
  matchContractSuccessPayloadType,
  ContractInfosSelectorType,
  ContractAutoInfoSelectorType,
  ContractMrhInfoSelectorType,
  ContratEpargnInfo,
} from 'store/contract/types';

const setContractsType = (payload: any): SetContractTypeData => ({
  type: SET_CONTRACTS_TYPE,
  payload,
});

const getContractType = () => ({
  type: GET_CONTRACTS_TYPE,
});

const matchContractSuccess = (
  payload: matchContractSuccessPayloadType,
): matchContractSuccessType => ({
  type: MATCH_CONTRACT_SUCCESS,
  payload,
});
const getContractsAuto = () => ({
  type: GET_CONTRACTS_AUTO,
});
const setContractsAuto = (payload: any): SetContractAutoData => ({
  type: SET_CONTRACTS_AUTO,
  payload,
});
const getContractsAutoFailed = (payload: any): contractAutoDataFailed => ({
  type: GET_CONTRACTS_AUTO_FAILED,
  payload,
});
const setInfoContract = (
  contract: ContractInfosSelectorType,
): SetContractInfoType => ({
  type: SET_CONTRACT_INFO,
  payload: contract,
});
const getDetailContract = (
  payload: ContractAutoInfoSelectorType,
): GetDetailContractType => ({
  type: GET_CONTRACT_DETAIL,
  payload,
});
const setDetailContract = (payload: any): SetDetailContractType => ({
  type: SET_CONTRACT_DETAIL,
  payload,
});
const setDetailContractFile = (payload: any): GetDetailContractFileType => ({
  type: SET_CONTRACT_DETAIL_FILES,
  payload,
});
const setDetailContractService = (
  payload: any,
): SetDetailContractServiceType => ({
  type: SET_CONTRACT_DETAIL_SERVICES,
  payload,
});
const setDetailContractGaranties = (
  payload: any,
): SetDetailContractGrantiesType => ({
  type: SET_CONTRACT_DETAIL_GARANTIES,
  payload,
});
const getDetailContractFailed = (
  payload: any,
): GetDetailContractFailedType => ({
  type: GET_CONTRACT_DETAIL_FAILED,
  payload,
});
const getContractsMrh = (): GetContractMrhTypeData => ({
  type: GET_CONTRACTS_MRH,
});
const setContractsMrh = (payload: string): setContractsMrhType => ({
  type: SET_CONTRACTS_MRH,
  payload,
});
const getContractsMrhFailed = (payload: string): getContractsMrhFailedType => ({
  type: GET_CONTRACTS_MRH_FAILED,
  payload,
});
const addNewContract = (payload: any): addNewContractType => ({
  type: ADD_NEW_CONTRACT,
  payload: payload,
});
const addNewContractFailed = (payload: any): addNewContractFailedType => ({
  type: ADD_NEW_CONTRACT_FAILED,
  payload,
});
const openModalSucces = (): openModalSuccessModal => ({
  type: OPEN_MODAL_SUCCESS_CONTRACT,
});
const closeModalSucces = (): closeModalSuccessModal => ({
  type: CLOSE_MODAL_SUCCESS_CONTRACT,
});

const openAddNewContractModal = (): openAddNewContractModalType => ({
  type: OPEN_ADD_NEW_CONTRACT_MODAL,
});
const closeAddNewContractModal = (): closeAddNewContractModalType => ({
  type: CLOSE_ADD_NEW_CONTRACT_MODAL,
});
const getDetailsContractMrh = (
  payload: ContractMrhInfoSelectorType,
): getDetailsContractMrhType => ({
  type: GET_DETAILS_CONTRACT_MRH,
  payload,
});
const setDetailContractMrh = (payload: any): setDetailsContractMrhType => ({
  type: SET_DETAILS_CONTRACT_MRH,
  payload,
});
const getDetailsContractMrhFailed = (
  payload: string,
): getDetailContractMrhFailedType => ({
  type: SET_DETAILS_CONTRACT_MRH_FAILED,
  payload,
});
const setDetailsContractMrhGaranties = (
  payload: string,
): setDetailsContractMrhGarantiesType => ({
  type: SET_DETAILS_CONTRACT_MRH_GARANTIES,
  payload,
});
const setDetailsContractMrhFiles = (
  payload: { url: string; title: string }[],
): setDetailsContractMrhFilesType => ({
  type: SET_DETAILS_CONTRACT_MRH_FILES,
  payload,
});
const getContractsEpargn = (): GetContractEpargnTypeData => ({
  type: GET_CONTRACTS_EPARGN,
});
const setContractsEpargn = (payload: any): setContractsEpargnType => ({
  type: SET_CONTRACTS_EPARGN,
  payload,
});
const getContractsEpargnFailed = (
  payload: string,
): getContractsEpargnFailedType => ({
  type: GET_CONTRACTS_EPARGN_FAILED,
  payload,
});
const getProduitEpargn = (): getProduitEpargnType => ({
  type: GET_PRODUIT_EPARGN,
});
const setProduitEpargn = (payload: any): setProduitEpargnType => ({
  type: SET_PRODUIT_EPARGN_SUCCESS,
  payload,
});
const setAuthContratEpargn = (payload: any): setAuthContratEpargnType => ({
  type: SET_AUTH_CONTRACT_EPARGN_INFO,
  payload,
});
const getProduitEpargnFailed = (
  payload: string,
): getProduitEpargnFailedType => ({
  type: GET_PRODUIT_EPARGN_FAILED,
  payload,
});
export type ContractActionType =
  | SetContractTypeData
  | GetContractTypeData
  | matchContractSuccessType
  | SetContractAutoData
  | GetContractAuto
  | contractAutoDataFailed
  | SetContractInfoType
  | GetDetailContractType
  | SetDetailContractType
  | GetDetailContractFailedType
  | GetDetailContractFileType
  | GetContractMrhTypeData
  | setContractsMrhType
  | getContractsMrhFailedType
  | SetDetailContractServiceType
  | addNewContractType
  | addNewContractFailedType
  | openModalSuccessModal
  | closeModalSuccessModal
  | SetDetailContractGrantiesType
  | openAddNewContractModalType
  | closeAddNewContractModalType
  | getDetailsContractMrhType
  | setDetailsContractMrhType
  | getDetailContractMrhFailedType
  | setDetailsContractMrhGarantiesType
  | setDetailsContractMrhFilesType
  | GetContractEpargnTypeData
  | setContractsEpargnType
  | getContractsEpargnFailedType
  | getProduitEpargnType
  | setProduitEpargnType
  | setAuthContratEpargnType
  | getProduitEpargnFailedType
  | GetContractsAMCType
  | SetContractsAMCType
  | GetContractsAMCFailedType
  | SetContractAMCBeneficiariesType
  | GetContractAMCBeneficiariesFailedType
  | SetClientContratsType
  | SetContractAMCDetailsType;

type SetContractTypeData = ActionWithPayloadType<
  typeof SET_CONTRACTS_TYPE,
  string
>;
type SetContractAutoData = ActionWithPayloadType<
  typeof SET_CONTRACTS_AUTO,
  string
>;
type contractAutoDataFailed = ActionWithPayloadType<
  typeof GET_CONTRACTS_AUTO_FAILED,
  string
>;
type GetContractAuto = ActionWithoutPayloadType<typeof GET_CONTRACTS_AUTO>;

type GetContractTypeData = ActionWithoutPayloadType<typeof GET_CONTRACTS_TYPE>;

type GetContractMrhTypeData = ActionWithoutPayloadType<
  typeof GET_CONTRACTS_MRH
>;
type matchContractSuccessType = ActionWithPayloadType<
  typeof MATCH_CONTRACT_SUCCESS,
  matchContractSuccessPayloadType
>;

type SetContractInfoType = ActionWithPayloadType<
  typeof SET_CONTRACT_INFO,
  ContractInfosSelectorType
>;
type GetDetailContractType = ActionWithPayloadType<
  typeof GET_CONTRACT_DETAIL,
  ContractAutoInfoSelectorType
>;
type SetDetailContractType = ActionWithPayloadType<
  typeof SET_CONTRACT_DETAIL,
  any
>;
type GetDetailContractFailedType = ActionWithPayloadType<
  typeof GET_CONTRACT_DETAIL_FAILED,
  string
>;

type GetDetailContractFileType = ActionWithPayloadType<
  typeof SET_CONTRACT_DETAIL_FILES,
  string
>;
type SetDetailContractServiceType = ActionWithPayloadType<
  typeof SET_CONTRACT_DETAIL_SERVICES,
  string
>;
type SetDetailContractGrantiesType = ActionWithPayloadType<
  typeof SET_CONTRACT_DETAIL_GARANTIES,
  string
>;
type setContractsMrhType = ActionWithPayloadType<
  typeof SET_CONTRACTS_MRH,
  string
>;
type getContractsMrhFailedType = ActionWithPayloadType<
  typeof GET_CONTRACTS_MRH_FAILED,
  string
>;
type addNewContractType = ActionWithPayloadType<typeof ADD_NEW_CONTRACT, any>;
type addNewContractFailedType = ActionWithPayloadType<
  typeof ADD_NEW_CONTRACT_FAILED,
  any
>;
type openModalSuccessModal = ActionWithoutPayloadType<
  typeof OPEN_MODAL_SUCCESS_CONTRACT
>;
type closeModalSuccessModal = ActionWithoutPayloadType<
  typeof CLOSE_MODAL_SUCCESS_CONTRACT
>;
type openAddNewContractModalType = ActionWithoutPayloadType<
  typeof OPEN_ADD_NEW_CONTRACT_MODAL
>;
type closeAddNewContractModalType = ActionWithoutPayloadType<
  typeof CLOSE_ADD_NEW_CONTRACT_MODAL
>;
type getDetailsContractMrhType = ActionWithPayloadType<
  typeof GET_DETAILS_CONTRACT_MRH,
  ContractMrhInfoSelectorType
>;
type setDetailsContractMrhType = ActionWithPayloadType<
  typeof SET_DETAILS_CONTRACT_MRH,
  any
>;
type getDetailContractMrhFailedType = ActionWithPayloadType<
  typeof SET_DETAILS_CONTRACT_MRH_FAILED,
  string
>;
type setDetailsContractMrhGarantiesType = ActionWithPayloadType<
  typeof SET_DETAILS_CONTRACT_MRH_GARANTIES,
  string
>;
type setDetailsContractMrhFilesType = ActionWithPayloadType<
  typeof SET_DETAILS_CONTRACT_MRH_FILES,
  { url: string; title: string }[]
>;
type GetContractEpargnTypeData = ActionWithoutPayloadType<
  typeof GET_CONTRACTS_EPARGN
>;
type setContractsEpargnType = ActionWithPayloadType<
  typeof SET_CONTRACTS_EPARGN,
  string
>;
type getContractsEpargnFailedType = ActionWithPayloadType<
  typeof GET_CONTRACTS_EPARGN_FAILED,
  string
>;
type getProduitEpargnType = ActionWithoutPayloadType<typeof GET_PRODUIT_EPARGN>;
type setProduitEpargnType = ActionWithPayloadType<
  typeof SET_PRODUIT_EPARGN_SUCCESS,
  string
>;
type getProduitEpargnFailedType = ActionWithPayloadType<
  typeof GET_PRODUIT_EPARGN_FAILED,
  string
>;

type setAuthContratEpargnType = ActionWithPayloadType<
  typeof SET_AUTH_CONTRACT_EPARGN_INFO,
  ContratEpargnInfo
>;

type SetContractsAMCType = ActionWithPayloadType<typeof SET_CONTRACTS_AMC, any>;
type GetContractsAMCFailedType = ActionWithPayloadType<
  typeof GET_CONTRACTS_AMC_FAILED,
  string
>;
type GetContractsAMCType = ActionWithoutPayloadType<typeof GET_CONTRACTS_AMC>;

const getContractsAMC = (): GetContractsAMCType => ({
  type: GET_CONTRACTS_AMC,
});

const setContractsAMC = (payload: any): SetContractsAMCType => ({
  type: SET_CONTRACTS_AMC,
  payload,
});

const getContractsAMCFailed = (payload: string): GetContractsAMCFailedType => ({
  type: GET_CONTRACTS_AMC_FAILED,
  payload,
});

type SetClientContratsType = ActionWithPayloadType<
  typeof SET_CLIENT_CONTRACT_ASI,
  any
>;
const setContratsASI = (payload: any): SetClientContratsType => ({
  type: SET_CLIENT_CONTRACT_ASI,
  payload,
});

type GetClientContratsType = ActionWithPayloadType<
  typeof GET_CLIENT_CONTRACT_ASI,
  Object
>;
const getContratsASI = (payload: {}): GetClientContratsType => ({
  type: GET_CLIENT_CONTRACT_ASI,
  payload,
});

type SetContractAMCBeneficiariesType = ActionWithPayloadType<
  typeof SET_CONTRACT_AMC_BENEFICIARIES,
  any
>;
const setContractAMCBeneficiaries = (
  payload: any,
): SetContractAMCBeneficiariesType => ({
  type: SET_CONTRACT_AMC_BENEFICIARIES,
  payload,
});

type GetContractAMCBeneficiariesFailedType = ActionWithPayloadType<
  typeof GET_CONTRACT_AMC_BENEFICIARIES_FAILED,
  string
>;
const getContractAMCBeneficiariesFailed = (
  payload: string,
): GetContractAMCBeneficiariesFailedType => ({
  type: GET_CONTRACT_AMC_BENEFICIARIES_FAILED,
  payload,
});

type SetContractAMCDetailsType = ActionWithPayloadType<
  typeof SET_CONTRACTS_AMC_DETAIL,
  any
>;
const setContractAMCDetails = (payload: any): SetContractAMCDetailsType => ({
  type: SET_CONTRACTS_AMC_DETAIL,
  payload,
});

type GetContractAMCDetailsType = ActionWithPayloadType<
  typeof GET_CONTRACTS_AMC_DETAIL,
  Object
>;
const getContractAMCDetails = (payload: {}): GetContractAMCDetailsType => ({
  type: GET_CONTRACTS_AMC_DETAIL,
  payload,
});

export {
  setContractsType,
  getContractType,
  matchContractSuccess,
  getContractsAuto,
  setContractsAuto,
  getContractsAutoFailed,
  setInfoContract,
  getDetailContract,
  setDetailContract,
  getDetailContractFailed,
  setDetailContractFile,
  setDetailContractService,
  setDetailContractGaranties,
  getContractsMrh,
  setContractsMrh,
  getContractsMrhFailed,
  addNewContract,
  addNewContractFailed,
  openModalSucces,
  closeModalSucces,
  openAddNewContractModal,
  closeAddNewContractModal,
  getDetailsContractMrh,
  setDetailContractMrh,
  getDetailsContractMrhFailed,
  setDetailsContractMrhGaranties,
  setDetailsContractMrhFiles,
  getContractsEpargn,
  setContractsEpargn,
  getContractsEpargnFailed,
  getProduitEpargnFailed,
  getProduitEpargn,
  setProduitEpargn,
  setAuthContratEpargn,
  getContractsAMC,
  setContractsAMC,
  getContractsAMCFailed,
  setContractAMCBeneficiaries,
  getContractAMCBeneficiariesFailed,
  setContratsASI,
  getContratsASI,
  setContractAMCDetails,
  getContractAMCDetails,
};
